"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateCheckCodeRequestRequest = void 0;
var ValidateCheckCodeRequestRequest = /** @class */ (function () {
    function ValidateCheckCodeRequestRequest() {
    }
    return ValidateCheckCodeRequestRequest;
}());
exports.ValidateCheckCodeRequestRequest = ValidateCheckCodeRequestRequest;
;
//# sourceMappingURL=validateCheckCodeRequest.request.js.map